module.exports = __webpack_public_path__ + "static/media/sobre-mim.a7e444e1.png";